/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import ManageCustExclusionFields from './ManageCustExclusionFields'

const ManageCustomerExclusions = (props) => {

  return (
    <MainRouteSubRoutePage mainTitle='routeTitles.manageCustExclusions'>
      <ManageCustExclusionFields />
    </MainRouteSubRoutePage>
  )
}

export default ManageCustomerExclusions
